import { __ } from '@wordpress/i18n';
import {
  PanelBody,
  RangeControl,
  ToggleControl,
  __experimentalUnitControl as UnitControl,
} from '@wordpress/components';

const SLIDES_MIN = 1;
const SLIDES_MAX = 6;
/*
 * Fractions are the point of the step, not a tolerance: the slide width is
 * 100% divided by this, so 1.15 sizes slides at ~87% and leaves the next one
 * showing at the edge. The numeric input field is what makes an exact 1.15
 * typeable — dragging the track alone would be a poor way to land on it.
 */
const SLIDES_STEP = 0.05;

export default function LayoutPanel({ attributes, setAttributes }) {
  const { slidesPerView, gap, fadeEdges, fadeSize } = attributes;
  const spv = slidesPerView ?? { desktop: 1, tablet: 1, mobile: 1 };

  const updateSpv = (key) => (value) =>
    setAttributes({ slidesPerView: { ...spv, [key]: value } });

  return (
    <PanelBody title={__('Layout', 'brandy-blocks')} initialOpen={true}>
      <RangeControl
        label={__('Slides per view (desktop)', 'brandy-blocks')}
        help={__(
          'Fractions are allowed — 1.15 shows the next slide at the edge.',
          'brandy-blocks'
        )}
        value={spv.desktop}
        min={SLIDES_MIN}
        max={SLIDES_MAX}
        step={SLIDES_STEP}
        onChange={updateSpv('desktop')}
      />
      <RangeControl
        label={__('Slides per view (tablet)', 'brandy-blocks')}
        value={spv.tablet}
        min={SLIDES_MIN}
        max={SLIDES_MAX}
        step={SLIDES_STEP}
        onChange={updateSpv('tablet')}
      />
      <RangeControl
        label={__('Slides per view (mobile)', 'brandy-blocks')}
        value={spv.mobile}
        min={SLIDES_MIN}
        max={SLIDES_MAX}
        step={SLIDES_STEP}
        onChange={updateSpv('mobile')}
      />
      <UnitControl
        label={__('Gap between slides', 'brandy-blocks')}
        value={gap}
        onChange={(value) => setAttributes({ gap: value || '16px' })}
        units={[
          { value: 'px', label: 'px' },
          { value: 'rem', label: 'rem' },
          { value: 'em', label: 'em' },
        ]}
      />
      <ToggleControl
        label={__('Fade the edges', 'brandy-blocks')}
        help={__(
          'Slides dissolve into the background where they leave the slider. Only the sides that still have slides to reach are faded, so a slider parked at its first slide keeps a clean left edge.',
          'brandy-blocks'
        )}
        checked={!!fadeEdges}
        onChange={(value) => setAttributes({ fadeEdges: value })}
      />
      {fadeEdges && (
        <UnitControl
          label={__('Fade width', 'brandy-blocks')}
          help={__('How far into the slider the fade reaches.', 'brandy-blocks')}
          value={fadeSize}
          onChange={(value) => setAttributes({ fadeSize: value || '48px' })}
          units={[
            { value: 'px', label: 'px' },
            { value: 'rem', label: 'rem' },
            { value: '%', label: '%' },
          ]}
        />
      )}
    </PanelBody>
  );
}
